import React, { useEffect, useState, useCallback } from 'react';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { Input, Space, Card } from 'antd';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { RolesTable } from '@app/components/apps/Users/RolesTable';
import { Row, Col } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';

const routes = [
  {
    path: '/user-roles', // Absolute path
    breadcrumbName: 'User Roles',
  },
];
const AllUserRoles: React.FC = () => {
  const [searchValue, setSearchValue] = useState('');
  const { t } = useTranslation();

  const navigate = useNavigate();

  const handlebtnClick = () => {
    navigate('/add-roles');
  };

  const handleSearchText = (e: any) => {
    setSearchValue(e);
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <BaseBreadcrumbWithRender routes={routes} separator=">" />
        </Col>
        <Space style={{ marginBottom: '16px', justifyContent: 'space-between', width: '100%' }}>
          <BaseButton icon={<PlusOutlined />} type="primary" onClick={handlebtnClick}>
            {t('Add New User Role')}
          </BaseButton>
        </Space>
      </Row>
      <RolesTable />
    </>
  );
};

export default AllUserRoles;
